import './style.scss'

import { getRunTime, versionfunegt } from 'src/public-resource/libs/utils/index'
import GetQueryString from 'src/public-resource/get-query/index'
import { postWithSign } from 'src/public-resource/libs/yiapiRequest.js'

const { isYixinliApp, yixinliAPPVersion } = window.$platform
let HOST = getRunTime('//m.xinli001.com')

class VipLock {
  constructor(params) {
    this.isSshzv = +GetQueryString('sshzv') === 1
    this.isLogin = +window.baseInfo.user_id
    let { isSelected } = params
    if (!isSelected) return
    this.init(params)
  }
  showVipLock() {
    $('.vipLock').show()
  }
  init({ audioId, isSelected, userVip, isExchange, callback }) {
    if (!isSelected || this.audioId === audioId) return
    this.audioId = audioId
    this.callback = callback
    if (this.isSshzv && versionfunegt(yixinliAPPVersion, '7.0.1')) return
    if (userVip) {
      window.toast('会员自动解锁')
    } else if (!isExchange) {
      if (this.hasRender) {
        this.showVipLock()
      } else {
        this.hasRender = true
        this._render()
        this._bindEvent()
      }
    }
  }
  _render() {
    $('body').append(`
      <div class="vipLock">
        <div class="content">
          <span class="close">关闭</span>
          <p class="title">积分解锁收听</p>
          <p class="title">或加入会员免积分收听</p>
          <div class="credit">10积分解锁收听</div>
          <div class="join">加入鲸选会员免积分收听</div>
        </div>

        <div class="dialog">
          <div class="title">前往壹心理App赢积分<br />解锁精选内容</div>
          <div class="btn-box">
            <div class="left-btn">取消</div>
            <div class="right-btn">确认</div>
          </div>
        </div>
      </div>
    `)
  }
  _bindEvent() {
    let $vipLock = $('.vipLock')
    let $content = $vipLock.children('.content')
    let $dialog = $vipLock.children('.dialog')
    $content.children('.close').on('click', function() {
      $vipLock.hide()
    })
    $content.children('.credit').on('click', () => {
      if (this.isLogin) {
        postWithSign(
          getRunTime('//m.xinli001.com') + '/selected/exchange.json',
          {
            object_id: this.audioId,
            object_name: 'fm'
          }
        ).then(({ data: { code, msg } }) => {
          if (code === 0) {
            window.toast('您已成功解锁精选内容')
            $vipLock.hide()
            this.callback && this.callback()
          } else if (code === 10001) {
            if (isYixinliApp) {
              window.toast('当前账户积分不够，可前往每日福利做任务赚积分。')
            } else {
              $dialog.show()
            }
          } else if (code != 40001) {
            window.toast(msg)
          }
        })
      } else {
        this.toLogin()
      }
    })
    $content.children('.join').on('click', () => {
      if (this.isLogin) {
        window.location.href =
          getRunTime('//static.xinli001.com') +
          '/kc/index.html?channelId=522&sourceName=yxlm_fm#/platform/vip-pay'
      } else {
        this.toLogin()
      }
    })

    $dialog.find('.left-btn').on('click', function() {
      $dialog.hide()
    })
    $dialog.find('.right-btn').on('click', function() {
      $dialog.hide()
      let isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
      if (isIOS) {
        window.location.href =
          'https://itunes.apple.com/app/apple-store/id994051627?pt=1667142&ct=m5&mt=8'
      } else {
        window.location.href = `https://m.xinli001.com/download?utm_source=fm`
      }
    })
  }
  toLogin() {
    window.location.href = isYixinliApp
      ? 'yixinli://open_user_login'
      : window.baseInfo.login_jump_url ||
        `${HOST}/account/login` +
          '?next=' +
          encodeURIComponent(window.location.href)
  }
}

module.exports = VipLock



// WEBPACK FOOTER //
// ./src/public-resource/components/VipLock/index.js